<script context="module"></script>

<script>import { getBlockActions } from "../../../functions/get-block-actions";
import { getBlockProperties } from "../../../functions/get-block-properties";
export let includeBlockProps;
export let block;
export let context;
export let wrapperProps;
export let Wrapper;
$: attributes = () => {
    return includeBlockProps
        ? {
            ...getBlockProperties({
                block: block,
                context: $context,
            }),
            ...getBlockActions({
                block: block,
                rootState: $context.rootState,
                rootSetState: $context.rootSetState,
                localState: $context.localState,
                context: $context.context,
            }),
        }
        : {};
};
</script>

<svelte:component this={Wrapper} {...wrapperProps} attributes={attributes()}
  ><slot /></svelte:component
>